import { useState } from "react";
import "./Roles.css";

export default function AddRoles() {
  const [roleName, setRoleName] = useState("");
  const [roleDescription, setRoleDescription] = useState("");

  const handleSave = () => {
    if (!roleName.trim()) return;
    alert(`Role "${roleName}" saved!`);
    setRoleName("");
    setRoleDescription("");
  };

  const handleCancel = () => {
    setRoleName("");
    setRoleDescription("");
  };

  return (
    <div className="page-wrapper">
      <div className="roles-card">
        <div className="card-header">
          <h2 className="card-title">Roles</h2>
        </div>

        <div className="card-divider" />

        <div className="card-body">
          <div className="form-group">
            <label className="form-label" htmlFor="roleName">
              Role Name
            </label>
            <input
              id="roleName"
              type="text"
              className="form-input"
              value={roleName}
              onChange={(e) => setRoleName(e.target.value)}
              placeholder="Enter role name"
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="roleDescription">
              Role Description
            </label>
            <input
              id="roleDescription"
              type="text"
              className="form-input"
              value={roleDescription}
              onChange={(e) => setRoleDescription(e.target.value)}
              placeholder="Enter role description"
            />
          </div>

          <div className="card-actions">
            <button className="btn btn-save" onClick={handleSave}>
              Save
            </button>
            <button className="btn btn-cancel" onClick={handleCancel}>
              Cancel
            </button>
          </div>
        </div>

        <div className="card-divider" />
      </div>
    </div>
  );
}